import LegalLayout from "../components/LegalLayout";
import Markdown from "../components/Markdown";
import { useContent } from "../context/ContentContext";
import { DEFAULT_IMPRESSUM } from "../lib/legalDefaults";

export default function Impressum() {
  const { content } = useContent();
  const legal = content?.legal || {};
  const text = legal.impressum?.body || DEFAULT_IMPRESSUM;
  const updated = legal.impressum?.updated || "Mai 2026";
  return (
    <LegalLayout eyebrow="Legal · 01" title="Impressum" updated={updated}>
      <Markdown source={text} />
    </LegalLayout>
  );
}
